import snakeCase from 'lodash/snakeCase';

import { sendTrackingEvent } from 'tracking/utils/sendTrackingEvent';
import { parseLabel } from './parseLabel';

const getEventAttributes = (category: string, title: string, subCategory: string, slug: string) => {
  if (category === 'listings') {
    return {
      listings_title: title,
      listings_subcategory: subCategory,
    };
  }

  if (category === 'editorial') {
    return {
      editorial_content: title,
    };
  }

  if (category === 'calendar') {
    return {
      release_type: snakeCase(title),
      product_template_slug: slug,
    };
  }

  // throw new Error('Invalid header navigation category');
};

export const trackHeaderBreadcrumbClick = (
  label: string,
  title: string,
  subCategory: string,
  slug: string,
) => {
  const category = parseLabel(label);
  const eventAttributes = getEventAttributes(category, title, subCategory, slug);

  sendTrackingEvent(`HEADER_${category?.toUpperCase()}_DRILLDOWN_TAP`, eventAttributes);
};
